/**
 * Dictionary object
 */

module.exports = {

    ru : {
        increaseSize : 'Увеличить шрифт',
        decreaseSize : 'Уменьшить шрифт',
    },

    en : {
        increaseSize : 'Increase font',
        decreaseSize : 'Decrease font',
    },

};



//////////////////
// WEBPACK FOOTER
// ./src/js/dictionary.js
// module id = 2
// module chunks = 0